import { render, staticRenderFns } from "./ManagePriceOption.vue?vue&type=template&id=10a31358&"
import script from "./ManagePriceOption.vue?vue&type=script&lang=js&"
export * from "./ManagePriceOption.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports